
export function consoleLog(data: any) {
  // if (environment === ENVIRONMENT_TYPE.PRODUCTION) return;
  console.log(data);
}
